import {
  FieldDescription,
  FieldGroup,
  FieldLegend,
  FieldSeparator,
  FieldSet,
} from "@/client/components/shad/field";
import { adminFormOptions, defaultValues } from "./shared";
import { useAppForm } from "../form-context";
import { NameBlock } from "./blocks/NameBlock";
import { ContactBlock } from "./blocks/ContactBlock";
import { RoleBlock } from "./blocks/RoleBlock";
import { OPTBlock } from "./blocks/OPTBlock";
import { setUser } from "@/client/hooks/useUserQuery";
import { toast } from "sonner";
import { useNavigate } from "@tanstack/react-router";

export const AdminConfigForm = () => {
  // const { data, isLoading } = useMapConfig();
  const { mutateAsync } = setUser();
  const navigate = useNavigate();

  const form = useAppForm({
    ...adminFormOptions,
    defaultValues: defaultValues,

    onSubmit: async ({ value }) => {
      await mutateAsync(value);

      toast.success(`PIN: ${value.pin}`, {
        description: (
          <span className="mt-2 w-[320px] overflow-x-auto rounded-md bg-code py-4 text-code-foreground">
            PIN: {value.firstName} {value.lastName} has been added to the user
            list
          </span>
        ),
        position: "bottom-right",
        classNames: {
          content: "flex flex-col gap-2",
        },
        style: {
          "--border-radius": "calc(var(--radius)  + 4px)",
        } as React.CSSProperties,
      });

      form.reset();

      navigate({ to: "/settings/admin" });
    },
  });

  // if (isLoading) return <p>Loading...</p>;

  return (
    <form
      id="user-form"
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <FieldGroup>
        <NameBlock form={form} />
        <FieldSeparator />
        <OPTBlock form={form} />
        <FieldSeparator />
        <RoleBlock form={form} />
        <FieldSeparator />
        <ContactBlock form={form} />
        <FieldSeparator />

        <form.AppForm>
          <form.SubmitButton label="Add User" />
        </form.AppForm>
      </FieldGroup>
    </form>
  );
};
